/**
 * 模块名称: 订单详情
 * @author lids@372163.com
 */
import React, { useState, useEffect } from 'react'
import api from '@/api'
import moment from 'moment'
import {
	Steps,
	Descriptions,
	Button,
	Modal,
	Input,
	Icon,
	message,
  Spin,
  Select,
  InputNumber,
  DatePicker,
  Radio,
  Drawer
} from 'antd'
import { parseSearch, debounce, onUrge, judgeCryptoParamsUrl } from '@/utils'
import ConsumptionList from './ConsumptionList'

const { Step } = Steps
const DItem = Descriptions.Item
const { TextArea } = Input

let areaTxt = '', result = ''
let orderPageType = ''
let oprateHandleOkTimer = null
let paramsSX = ''

const DirectDetail = (props) => {
	const { history, location } = props
  const search = parseSearch(location.search)
  const [detail, setDetail] = useState({})
  const [base, setBase] = useState({})//基础信息
  const [row, setRow] = useState({})//基础信息
  const [client, setClient] = useState('')//客户信息
	const [auditProgress, setAuditProgress] = useState([])//审核进程
	const [contractInfo, setContractInfo] = useState({})//合同信息
	const [contactInfo, setContactInfo] = useState({})//联系人信息
	const [orderInfo, setOrderInfo] = useState({})//订单信息
	const [attachdata, setAttachdata] = useState([])//订单扩展资料字段信息
	const [orderExInfo, setOrderExInfo] = useState({})//订单资料
	const [colInfo, setColInfo] = useState({})//收款信息
  const [internalSettlement, setInternalSettlement] = useState(null)//内部结算信息
	const [vendor, setVendor] = useState([{}])//厂商ID信息
	const [attchments, setAttchments] = useState([])//附件信息
	const [discountInfo, setDiscountInfo] = useState({})//折扣信息
	const [aduitLog, setAduitLog] = useState([])//审核日志
	const [modalVisible, setModalVisible] = useState(false)
	const [pageId, setPageId] = useState('')
	const [loading, setLoading] = useState(true)
  const [resPlaceholder, setResPlaceholder] = useState('请输入至少1个字符')
  const [discountType, setDiscountType] = useState('')//折扣
  const [company, setCompany] = useState('')//订单转出时的公司id
  const [outSettle, setOutSettle] = useState('')//提交提交时的出结算
  const [distributionVisible, setDistributionVisible] = useState(false)
  const [disStaffName, setDisStaffName] = useState('')//提交分配时的员工id
  const [turnOutVisible, setTurnOutVisible] = useState(false)
  const [companyList, setCompanyList] = useState([])
  const [vendorClient, setVendorClient] = useState('')
  const [vendorId, setVendorId] = useState('')
  const [account, setAccount] = useState('')
  const [password, setPassword] = useState('')
  const [websitexz, setWebsitexz] = useState('')
  const [industry, setIndustry] = useState('')
  const [area, setArea] = useState('')
  const [dqdate, setDqdate] = useState('1970-01-01')
  const [jkstatus, setJkstatus] = useState('')
  const [iskpi, setIskpi] = useState('')
  const [money, setMoney] = useState('')
  const [delay, ] = useState(3000)
  const [operateDisabled, setOperateDisabled] = useState(false)
  const [original, setOriginal] = useState([]) // 原订单流水分成信息
	const [performance, setPerformance] = useState([])//分成人信息
  const [submitted, onSubmitted] = useState('')//提交部门审批意见'
  const [accDcorderInfo, setAccDcorderInfo] = useState({})//订单消耗信息
  const [useinfoVisible, setUseinfoVisible] = useState(false)
  const [useinfoLoading, setUseinfoLoading] = useState(false)
  const [adrId, setAdrId] = useState('')
  //操作权限
  const [auditAuth, setAuditAuth] = useState(false)//设置按钮组是否展示
  const [hasChargerPower, setHasChargerPower] = useState(false)//设置驳回和通过按钮是否展示（订单同时控制展示不展示手里提交和生效 以及 折扣节点，此4个按钮在它的基础上再根据currentStatus判断是否展示）
  const [distribution, setDistribution] = useState(false)//设置分配按钮是否展示
  const [replenish, setReplenish] = useState(false)//设置补充资料按钮是否展示
  const [returnUp, setReturnUp] = useState(false)//设置转上级按钮是否展示
  const [currentStatus, setCurrentStatus] = useState('')//设置审批节点，是否展示提交 生效 和 受理 以及折扣节点
  const [rejectMsgRequire, setRejectMsgRequire] = useState(false)//设置审批意见驳回必填
  const [vendorFocus, setvendorFocus] = useState(false)
  const [vendorVisible, setVendorVisible] = useState(false)
  const [vendorCharsVisible, setVendorCharsVisible] = useState(false)
  const [showOrigina, setShowOrigina] = useState(0)
  const [reviewLoading, setReviewLoading] = useState(false) // 审批确定loading
  const [urge, setUrge] = useState(false)
	const [businessNo, setBusinessNo] = useState('')
  const [userAuth, setUserAuth] = useState(false) //判断是否展示补充资料重提按钮
  const [portIdentify, setPortIdentify] = useState('') // 端口识别号
  const [originalVendorId, setOriginalVendorId] = useState('') // 原始厂商ID
  const [portList, setPortList] = useState([])

	useEffect(() => {
    //判断是直销还是代理商页面跳转
    if(location.pathname && location.pathname.indexOf('/orderAgent') > -1){
      orderPageType = 'Agent'
    }else{
      orderPageType = 'Direct'
    }
    if (judgeCryptoParamsUrl(search)) {
      areaTxt = ''
      result = ''
      setPageId(search.id)
      getFortuneOrderDetail(search.id)
    } else {
      message.error('没有本页访问权限')
      let timer = setTimeout(() => {
        history.go(-2)
        clearTimeout(timer)
      }, 1000)
    }
	}, [])
	//获取详情
	const getFortuneOrderDetail = (id) => {
		api[`getFortuneOrder${orderPageType}Detail`]({id: id, type: 0}).then(res => {
      setOperateDisabled(false)
      if (res.orderInfo.isDel === 1) {
        message.error('该申请已被申请人删除，无法进行审批。')
        setTimeout(() => {
          history.goBack()
        }, 1500)
        return
      }
			if (search.msgId) {
				api.setMessageReaded({ ids: [search.msgId] })
			}
			if(JSON.stringify(res) !== "[]"){
				const data = Object.assign({}, res)
        const { modifyVendor, distributionStaff } = data
        setDetail({ modifyVendor, distributionStaff })
        data.base && setBase(data.base)
        setShowOrigina(data.showOrigina)
        setUserAuth(data.userAuth)
        if(data.row){
          setRow(data.row)
          if (modifyVendor !== -1) {
            api.getPortIdentifyList({
              supplierId: data.row.supplier,
              limit: 99999,
            }).then(portData => {
              setPortList(portData.list)
              if (data.row.supplier === data.vendor.supplier) {
                setPortIdentify(data.vendor.portIdentify)
              } else {
                if (portData.list.length === 1) {
                  setPortIdentify(portData.list[0].portIdentify)
                }
              }
            })
          }
          if((modifyVendor === 2 || modifyVendor === 1) && data.vendor){
            setVendorId(data.vendor.vendor)
            setVendorClient(data.vendor.vendorClient)
            setAccount(data.vendor.account)
            setPassword(data.vendor.password)
            setWebsitexz(data.vendor.websitexz)
            setIndustry(data.vendor.industry)
            setArea(data.vendor.area)
            setDqdate(data.vendor.dqdate)
            setJkstatus(data.vendor.jkstatus == '未结款' ? 0 : 1)
            setIskpi(data.vendor.iskpi == '是' ? 1 : 0)
            setMoney(data.vendor.money == '现金' ? 1 : data.vendor.money == '虚拟金' ? 2 : 3)
            setOriginalVendorId(data.vendor.originalVendorId)
          }
        }
        data.client && setClient(data.client)
        data.currentStatus && setCurrentStatus(data.currentStatus)
        data.contractInfo && setContractInfo(data.contractInfo)
        data.contactInfo && setContactInfo(data.contactInfo)
        data.orderInfo && setOrderInfo(data.orderInfo)
        if(data.orderExInfo){
          setOrderExInfo(data.orderExInfo)
          if(data.orderExInfo.attachdata && data.orderExInfo.attachdata.length){
            data.orderExInfo.attachdata.forEach((item, index, self) => {
              self[index] = {
                name: Object.keys(item)[0],
                value: Object.values(item)[0]
              }
            })
            setAttachdata(data.orderExInfo.attachdata)
          }
        } 
        data.colInfo && setColInfo(data.colInfo)
        data.originaData && setOriginal(data.originaData)
        data.performance && setPerformance(data.performance)
        data.vendor && setVendor(data.vendor)
        data.attchments && setAttchments(data.attchments)
        data.discountInfo && setDiscountInfo(data.discountInfo)
        data.aduitLog && setAduitLog(data.aduitLog)
        data.accDcorderInfo && setAccDcorderInfo(data.accDcorderInfo)
        data.internalSettlement && setInternalSettlement(data.internalSettlement)

        // 提交出结算设置初始值
        const condition = ['广点通','腾讯社交广告','腾讯社交广告行业一','爱奇艺','爱奇艺KA','360','腾讯办公QQ','腾讯营销QQ','腾讯企点','腾讯企点ISV']
        if(condition.includes(data.orderInfo.projectName) ){
          if (data.buttonAuthList.hasChargerPower && data.currentStatus == '提交提交') {
            setOutSettle(+data.colInfo.colmarketprice)
          }
        }

        if(data.auditProgress){
          let auditProgress = data.auditProgress
          auditProgress.forEach((item, index, self) => {
            if(item.persons && item.persons.length){
              self[index].persons = item.persons.join('，')
            }
          })
          setAuditProgress(auditProgress)
        }
        if(data.buttonAuthList && JSON.stringify(data.buttonAuthList) !== '[]'){
          setAuditAuth(true)
          setHasChargerPower(data.buttonAuthList.hasChargerPower)
          setReplenish(data.buttonAuthList.replenish)
          setDistribution(data.buttonAuthList.distribution)
					setReturnUp(data.buttonAuthList.return_up)
					setRejectMsgRequire(data.buttonAuthList.reject_msg_require)
          setUrge(data.buttonAuthList.urge)
					setBusinessNo(data.buttonAuthList.businessNo)
        }else{
          setAuditAuth(false)
          setHasChargerPower(false)
          setReplenish(false)
          setDistribution(false)
					setReturnUp(false)
					setRejectMsgRequire(false)
          setUrge(false)
					setBusinessNo('')
        }
			}else{
				setDetail({})
        setBase({})
        setClient({})
        setAuditProgress([])
        setCurrentStatus('')
        setContractInfo({})
        setContactInfo({})
        setAccDcorderInfo({})
        setOrderInfo({})
        setAttachdata([])
        setOrderExInfo({})
        setColInfo({})
        setOriginal([])
        setPerformance([])
        setVendor({})
        setAttchments([])
        setDiscountInfo({})
        setAduitLog([])
        setInternalSettlement(null)
			}
			setLoading(false)
		})
	}
	//点击好几个审批的按钮
	const leaveOutAudit = (no) => {
    areaTxt = ''
    result = no
    //通过
    if(no == 0){//eslint-disable-line
		  setResPlaceholder('请输入审批意见')
      setModalVisible(true)
    //驳回
    }else if(no == 1){//eslint-disable-line
			//审批意见是否为必填项改由审批流控制 2020年2月22日 17:19:23
		  setResPlaceholder('请输入审批意见')
      setModalVisible(true)
    //转上级
    }else if(no == 2){
		  setResPlaceholder('请输入审批意见')
      setModalVisible(true)
    //补充资料
    }else if(no == 3){
		  setResPlaceholder('请输入审批意见')
      setModalVisible(true)
    //分配
    }else if(no == 4){
      setDistributionVisible(true)
    //转出
    }else if(no == 5){
      setTurnOutVisible(true)
      api.getCorp({ limit: global.paramsLimit }).then(res => {
        let list = []
        res.list.forEach(item => {
          if (item.isValid === 1) list.push(item)
        })
        setCompanyList([...list])
      })
    //受理
    }else if(no == 6){
      oprateHandleOk()
    //已提交
    }else if(no == 7){
      if(outSettle == null || outSettle === '')return message.warning('出结算不能为空')
      oprateHandleOk()
    //生效
    }else if(no == 8){
      if(vendorClient === '')return message.warning('厂商客户名称不能为空')
      if(vendorId === '')return message.warning('厂商ID不能为空')
      if(account === '')return message.warning('厂商客户账号不能为空')
      if(jkstatus === '')return message.warning('结款状态为必选')
      if(iskpi === '')return message.warning('请确认是否算KPI')
      if(money === '')return message.warning('充值类型为必选')
      if(portIdentify === '') return message.warning('端口识别号为必选')
      if(originalVendorId === '') return message.warning('原始厂商ID不能为空')
      paramsSX = {
        vendorClient,
        vendor: vendorId,
        account,
        password,
        websitexz,
        money,
        industry,
        area,
        dqdate,
        jkstatus,
        iskpi,
        portIdentify,
        originalVendorId,
      }
      if(paramsSX.dqdate == '1970-01-01')paramsSX.dqdate = ''
      oprateHandleOk()
    //补充资料、转上级 2 3
    }else{
      setOperateDisabled(true)
      api.onFortuneOrderFlowAduit({
        id: pageId,
        type: result,
        remark: areaTxt,
        discountType
      }, true).then(() => {
        setDiscountType('')
        goAuduitList()
        // setOperateDisabled(false)
      }).catch(() => setOperateDisabled(false))     
    }
  }
  //跳转审批列表页
  const goAuduitList = () => {
    let timer = setTimeout(() => {
      history.push({
        pathname: `/order${orderPageType}/auditList`
      })
      onSubmitted('')
      setOperateDisabled(false)
      clearTimeout(timer)
    }, 1000)
  }
  // 审批
	const oprateHandleOk = () => {
    oprateHandleOkTimer = null
    return function(){
      if(oprateHandleOkTimer)clearTimeout(oprateHandleOkTimer)
      oprateHandleOkTimer = setTimeout(() => {
          clearTimeout(oprateHandleOkTimer)
          if(areaTxt.length < 1 && result == 1 && rejectMsgRequire){//eslint-disable-line
            return message.warning('请输入至少1个字符')
          }
          if(currentStatus === '折扣开始' && !discountType && result === 0){
            return message.warning('请选择折扣类型')
          }
          setReviewLoading(true)
          let params = {
            id: pageId,
            type: result,
            remark: areaTxt
          }
          if(discountType)params.discountType = discountType//折扣类型
          if (result == 8) { // 生效确定
            setOperateDisabled(true)
            api.onFortuneOrderFlowTakeEffect({ id: pageId, ...paramsSX, remark: submitted }, true).then(() => {
              setModalVisible(false)
              setReviewLoading(false)
              message.info('提交已生效成功')
              goAuduitList()
              // setOperateDisabled(false)
            }).catch(() => {
              setModalVisible(false)
              setOperateDisabled(false)
              setReviewLoading(false)
            })
          } else if (result == 7) { // 提交提交确定
            setOperateDisabled(true)
            api.onFortuneOrderFlowSubmit({ id: pageId, outSettle, remark: submitted }, true).then(() => {
              message.info('提交成功')
              onSubmitted('')
              getFortuneOrderDetail(pageId)
              // setOperateDisabled(false)
              setModalVisible(false)
              setReviewLoading(false)
            }).catch(() => {
              setOperateDisabled(false)
              setReviewLoading(false)
            })
          } else if (result == 6) { // 受理确定
            setOperateDisabled(true)
            api.onFortuneOrderFlowAccept({ id: pageId, remark: submitted }, true).then(() => {
              message.info('受理成功')
              onSubmitted('')
              getFortuneOrderDetail(pageId)
              // setOperateDisabled(false)
              setModalVisible(false)
              setReviewLoading(false)
            }).catch(() => {
              setOperateDisabled(false)
              setReviewLoading(false)
            })
          } else {
          api.onFortuneOrderFlowAduit(params, true).then(res => {
            setModalVisible(false)
            message.success('审批成功')
            setReviewLoading(false)
            setDiscountType('')
            getFortuneOrderDetail(pageId)
          }).catch(() => {
            setReviewLoading(false)
          })
        }
      }, 1500)
    }()	
	}
	//同意的样式
	const agreeNode = () => {
    if (result === 0) {
      return <>同意 <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" /></>
    } else if (result === 1) {
      return <>不同意 <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" /></>
    } else if (result === 2) {
      return <>转上级 <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" /></>
    } else if (result === 3) {
      return <>补充资料 <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" /></>
    } else if (result === 6) {
      return <>受理 <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" /></>
    } else if (result === 7) {
      return <>已提交 <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" /></>
    } else if (result === 8) {
      return <>生效 <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" /></>
    }
	}
	//审批意见
	const getAreaTxt = (e) => {
		areaTxt = e.target.value.trim()
  }
  //分配
	const oprateHandleOkDist = () => {
    if(disStaffName === '')return message.warning('请选择审批人')
    setReviewLoading(true)
		api.onFortuneOrderFlowDistribution({id: pageId, stfid: disStaffName}).then(() => {
      setDistributionVisible(false)
      message.info('分配成功')
      setReviewLoading(false)
      setDisStaffName('')
      getFortuneOrderDetail(pageId)
    }).catch(() => {
      setReviewLoading(false)
    })
	}
  //转出
	const oprateHandleOkturnOut = () => {
    if(company === '')return message.warning('请选择转出公司')
    if(outSettle == null || outSettle === '')return message.warning('出结算不能为空')
    api.onFortuneOrderFlowTurnOut({id: pageId, company, outSettle}).then(() => {
      message.info('转出成功')
      setTurnOutVisible(false)
      getFortuneOrderDetail(pageId)
    })
  }
  //保存厂商信息
  const onSaveVendorByModify = () => {
    if(vendorClient === '')return message.warning('厂商客户名称不能为空')
    if(vendorId === '')return message.warning('厂商ID不能为空')
    if(account === '')return message.warning('厂商客户账号不能为空')
    if(jkstatus === '')return message.warning('结款状态为必选')
    if(iskpi === '')return message.warning('请确认是否算KPI')
    if(money === '')return message.warning('充值类型为必选')
    if(portIdentify === '') return message.warning('端口识别号为必选')
    if(originalVendorId === '') return message.warning('原始厂商ID不能为空')
    let params = {
      id: vendor.id,
      vendorClient,
      vendor: vendorId,
      account,
      password,
      websitexz,
      money,
      industry,
      area,
      dqdate,
      jkstatus,
      iskpi,
      orderId: pageId,
      portIdentify,
      originalVendorId,
    }
    if(params.dqdate == '1970-01-01')params.dqdate = ''
    api.onSaveVendorByModify(params).then(() => {
      message.info('修改厂商信息成功')
    })
  }

  //退回列表页
  const onGoBack = () => {
    //跳转直销已完成列表页
    if (search.type == 'finishzhi') {
      history.push({pathname:'/orderDirect/finishedList',state: { goBack: 1}})
    }
    //跳转直销审批中列表页
    if (search.type == 'unfinishedzhi') {
      history.push({pathname:'/orderDirect/auditList',state: { goBack: 1}})
    }
    //跳转直销所有列表页
    if (search.type == 'allzhi') {
      history.push({pathname:'/orderDirect/allDirectList',state: { goBack: 1}})
    }
    //跳转代理商已完成列表页
    if (search.type == 'finishqu') {
      history.push({pathname:'/orderAgent/finishedList',state: { goBack: 1}})
    }
    //跳转代理商审批中列表页
    if (search.type == 'unfinishedqu') {
      history.push({pathname:'/orderAgent/auditList',state: { goBack: 1}})
    }
    //跳转代理商所有列表页
    if (search.type == 'allqu') {
      history.push({pathname:'/orderAgent/allAgentList',state: { goBack: 1}})
    }
  }

  // 厂商id失焦
  const onVendorBlur = () => {
    if(vendorId !== '') {
      // 半角空格
      const reg = /^[^ ]+$/
      if (!reg.test(vendorId)) {
        setVendorVisible(true)
        setvendorFocus(true)
        return
      } 
      // 全角空格
      const regs = /^[^　]+$/
      if (!regs.test(vendorId)) {
        setVendorVisible(true)
        setvendorFocus(true)
        return
      } 

      const reg1 = /－/g
      if (reg1.test(vendorId)) {
        setVendorCharsVisible(true)
        setvendorFocus(true)
        return
      } 
      setvendorFocus(false)  
    }
  }  

  const onConsumptionList = () => {
    setUseinfoVisible(true)
    setAdrId(accDcorderInfo.adr_id)
  }

  const submitTyle = () => {
    if (currentStatus == '提交受理') {
      return '请输入受理审批意见'
    } else if (currentStatus == '提交提交') {
      return '请输入提交审批意见'
    } else if (currentStatus == '提交生效') { 
      return '请输入生效审批意见'
    } else {
      return '请输入'
    }
  }

	return (
		<Spin spinning={loading}>
      {
        search.type &&  <Button onClick={onGoBack} type="primary" style={{
          position: 'absolute',
          right: '20px',
          top: '0px'
        }}>返回上一页</Button>
      }
			<div className="add-orderDirect-detail">
        <Descriptions title={`${orderPageType == 'Direct' ? '直销订单' : '代理商订单'}-${base.coltype || ''}-${base.number || ''}`} layout="vertical" className="pro-detail-title" column={5} style={{borderBottom: "none"}}>
          <DItem label="客户名称">{client.name}</DItem>
          <DItem label="OAID">{client.id}</DItem>
          {base.orderType && !Array.isArray(base.orderType) && <DItem label="类型">{base.orderType.name}</DItem>}
          {row.agent && orderPageType == 'Agent' && <DItem label="代理商名称">{row.agent}</DItem>}
          {row.agentId && orderPageType == 'Agent' && <DItem label="QID">{row.agentId}</DItem>}
          {vendor.vendor && <DItem label="厂商ID">{vendor.vendor}</DItem>}
          {vendor.vendor && orderPageType == 'Direct' && <DItem label="所属销售">{vendor.relSalerName}</DItem>}
          {vendor.vendor && orderPageType == 'Direct' && <DItem label="所属客服">{vendor.relServicerName}</DItem>}
          {vendor.vendor && orderPageType == 'Agent' && <DItem label="代理商所属开发">{vendor.relAgentStaffName}</DItem>}
          {vendor.vendor && orderPageType == 'Agent' && <DItem label="提单人">{colInfo.userName}</DItem>}
        </Descriptions>
        {auditProgress.length > 0 && <>
          <div className="blank-line"></div>
          <div className="step-wrap">
            <div className="record-list-title">当前审批进度&nbsp;
              {auditAuth && urge && <Button type='primary' size="small" onClick={() => onUrge(`urgeOrder${orderPageType}`, businessNo)}>催一催</Button>}
            </div>
            <Steps>
            {
              auditProgress.map((item, index) => {
                let status = 'wait'
                if (item.time && item.time.length > 1) {
                  status = 'process'
                }
                return <Step status={status} title={item.nodeName} key={index} description={
                  <>
                    {item.persons && <div title={item.persons}>{item.persons}</div>}
                    <div title={item.statusName}>{item.statusName}</div>
                    <div title={item.time}>{item.time}</div>
                  </>
                } />
              })
            }
            </Steps>					
          </div>
        </>}
        <div className="blank-line"></div>
        <div className="ask-info">
          <div className="record-list-title">合同信息</div>
					{contractInfo && JSON.stringify(contractInfo) !== '{}' ? <Descriptions layout="vertical" className="pro-detail-title" column={4} style={{borderBottom: "none"}}>
						<DItem label="客户姓名">{contractInfo.customerName}</DItem>
						<DItem label="合同编号">{contractInfo.contractNo}</DItem>
						<DItem label="合同名称">{contractInfo.templateName}</DItem>
            <DItem label="合同主体">
              {
                contractInfo.clientSource == 1
                  ? (contractInfo.templateId === 9 ? contractInfo.partB : contractInfo.partA)
                  : contractInfo.partB
              }
            </DItem>
						<DItem label="合同有效期">{contractInfo.term}</DItem>
					</Descriptions> : '-'}
        </div>
        <div className="blank-line"></div>
        <div className="ask-info">
          <div className="record-list-title">订单联系人</div>
					{contactInfo ? <Descriptions layout="vertical" className="pro-detail-title" column={4} style={{borderBottom: "none"}}>
						<DItem label="订单联系人">{contactInfo.contactname}</DItem>
						<DItem label="手机">{contactInfo.contactmobile}</DItem>
						<DItem label="座机">{contactInfo.contacttel}</DItem>
						<DItem label="传真">{contactInfo.contactfax}</DItem>
						<DItem label="邮箱">{contactInfo.contactemail}</DItem>
						<DItem label="QQ">{contactInfo.contactqq}</DItem>
					</Descriptions> : '-'}
        </div>
        <div className="blank-line"></div>
        <div className="ask-info">
          <div className="record-list-title">订单信息</div>
					{orderInfo ? <Descriptions layout="vertical" className="pro-detail-title" column={4} style={{borderBottom: "none"}}>
						<DItem label="项目">{orderInfo.projectName}</DItem>
						<DItem label="产品">{orderInfo.productName}</DItem>
						<DItem label="业务类型">{orderInfo.businessName}</DItem>
						<DItem label="业绩类型">{orderInfo.figtype}</DItem>
						{orderPageType == 'Direct' && <DItem label="是否退转订单">{+row.isodftrun ? '是' : '否'}</DItem>}
						{orderPageType == 'Direct' && <DItem label="是否框架订单">{row.isodfkjia ? '是' : '否'}</DItem>}
						{orderPageType == 'Direct' && <DItem label="销售主项">{row.majorminor == 1 ? '是' : '否'}</DItem>}
            {orderPageType == 'Agent' && <DItem label="代理商名称">
              <div>{orderInfo.agentName}</div>
              <div>ID: {orderInfo.agentId}</div>
            </DItem>}
					</Descriptions> : '-'} 
        </div>
        <div className="blank-line"></div>
        <div className="ask-info">
          <div className="record-list-title">订单资料</div>
					{orderExInfo ? <Descriptions layout="vertical" className="pro-detail-title" column={4} style={{borderBottom: "none"}}>
						<DItem label="公司名称">{orderExInfo.companyName}</DItem>
						<DItem label="一级行业">{orderExInfo.industry1Name}</DItem>
						<DItem label="二级行业">{orderExInfo.industry2Name}</DItem>
						<DItem label="供应商">{orderExInfo.supplierName}</DItem>
						<DItem label={<span className='font-striking'>提单主体</span>}><span className='font-striking-content'>{orderExInfo.supplierCompanyName}</span></DItem>
            {
              attachdata.map(((item, index) => <DItem label={item.name !== '备注' ? item.name : <span className='font-striking'>备注</span>} key={+index+4}>{item.name !== '备注' ? item.value : <span className='font-striking-content'>{item.value}</span>}</DItem>))
            }
					</Descriptions> : '-'}
        </div>
        <div className="blank-line"></div>
        <div className="ask-info">
          <div className="record-list-title">订单收款信息-{base.coltype}</div>
					{colInfo ? <><Descriptions layout="vertical" className="pro-detail-title" column={4} style={{borderBottom: "none"}}>
						<DItem label="市场价">{colInfo.colmarketprice}</DItem> 
            <DItem label='实收'>{colInfo.colactualprice}</DItem>
            {(row.coltype == 2 || row.coltype == 5) && <DItem label='预计收款'>{colInfo.colpredictprice}</DItem>}
						<DItem label="折扣">{+colInfo.colmarketprice === 0 ? '纯利': colInfo.colrebate}</DItem>
						{orderPageType == 'Agent' && <DItem label="积分">{colInfo.integral}</DItem>}
          </Descriptions>
          <Descriptions layout="vertical" className="pro-detail-title" column={4} style={{borderBottom: "none"}}>
						<DItem label="成本">{colInfo.colcost}</DItem>
						<DItem label="调整项">{colInfo.colrefund}</DItem>
						<DItem label="个人利润">{colInfo.colprofit}</DItem>
            {colInfo.creditAccount && <DItem label="信用账户ID">{colInfo.creditAccount}（{colInfo.creditType}）</DItem>}
          </Descriptions>
          <Descriptions layout="vertical" className="pro-detail-title" column={4} style={{borderBottom: "none"}}>
						<DItem label="提单人">{colInfo.userName}</DItem>
						<DItem label="直接主管">{colInfo.userLeader}</DItem>
						<DItem label="部门">{colInfo.userDepart}</DItem>
            <DItem label="资金所属公司">{colInfo.fundCompanyName}</DItem>
					</Descriptions>
          {performance.length > 0 && <Descriptions layout="vertical" className="pro-detail-title" column={4} style={{borderBottom: "none", marginBottom: "-30px"}}>
            <DItem label="分成人"></DItem>
            <DItem label="分成人部门"></DItem>
            <DItem label="分成的订单业绩"></DItem>
            <DItem label="已生成的消耗业绩"></DItem>
          </Descriptions>}
          {performance.map((item, index) => (<Descriptions layout="horizontal" className="pro-detail-title" column={4} key={index} style={{borderBottom: "none", marginBottom: "-10px"}}>
            <DItem label="">{item.stfName}</DItem>
            <DItem label="">{item.department}</DItem>
            <DItem label="">{item.performance}</DItem>
            <DItem label="">{item.conPered}</DItem>
          </Descriptions>))}
          </> : '-'}
        </div>
        {
          showOrigina === 1 && <>
            <div className="blank-line"></div>
            <div className="ask-info">
              <div className="record-list-title">原订单流水与分成信息</div>
              {original.map((item, index) => (
                <div className="original-item" key={index}>
                  <Descriptions layout="vertical" className="pro-detail-title" column={4} style={{ borderBottom: "none" }}>
                    <DItem label="市场价">{item.colmarketprice}</DItem>
                    <DItem label='实收'>{item.colactualprice}</DItem>
                    {(row.coltype == 2 || row.coltype == 5) && <DItem label='预计收款'>{item.colpredictprice}</DItem>}
                    <DItem label="折扣">{+item.colmarketprice === 0 ? '纯利' : item.colrebate}</DItem>
                    {orderPageType == 'Agent' && <DItem label="积分">{item.integral}</DItem>}
                  </Descriptions>
                  <Descriptions layout="vertical" className="pro-detail-title" column={4} style={{ borderBottom: "none" }}>
                    <DItem label="成本">{item.colcost}</DItem>
                    <DItem label="调整项">{item.colrefund}</DItem>
                    <DItem label="个人利润">{item.colprofit}</DItem>
                  </Descriptions>
                  <Descriptions layout="vertical" className="pro-detail-title" column={4} style={{ borderBottom: "none" }}>
                    <DItem label="提单人">{item.userName}</DItem>
                    <DItem label="直接主管">{item.userLeaderName}</DItem>
                    <DItem label="部门">{item.userDeptName}</DItem>
                    <DItem label="资金所属公司">{item.fundCompanyName}</DItem>
                  </Descriptions>
                  {item.performance?.length > 0 && <Descriptions layout="vertical" className="pro-detail-title" column={4} style={{ borderBottom: "none", marginBottom: "-30px" }}>
                    <DItem label="分成人"></DItem>
                    <DItem label="分成人部门"></DItem>
                    <DItem label="分成的订单业绩"></DItem>
                    <DItem label="已生成的消耗业绩"></DItem>
                  </Descriptions>}
                  {item.performance?.map((k, v) => (<Descriptions layout="horizontal" className="pro-detail-title" column={4} key={v} style={{ borderBottom: "none", marginBottom: "-10px" }}>
                    <DItem label="">{k.stfName}</DItem>
                    <DItem label="">{k.department}</DItem>
                    <DItem label="">{k.performance}</DItem>
                    <DItem label="">{k.conPered}</DItem>
                  </Descriptions>))}
                </div>
              ))}
            </div>
          </>
        }
        <div className="blank-line"></div>
        <div className="ask-info">
          <div className="record-list-title">订单附件</div>
          <Descriptions title=""
            layout="horizontal"
            className="pro-detail-smailtitle"
          >
            <div className="content" style={{display: 'flex'}}>
              {
                attchments.length ? attchments.map((item, index) => {
                  return <div key={index}><a href={item.url} target="_blank" rel="noopener noreferrer">{item.name}</a></div>
                }) : '无'
              }
            </div>
          </Descriptions>
        </div>
        <div className="blank-line"></div>
        <div className="ask-info">
					<Descriptions title={<span className="font-striking">提单备注</span>} layout="horizontal" className="pro-detail-smailtitle">
            <div className="content">
              {orderInfo.remark ? <span className="font-striking-content">{orderInfo.remark}</span> : '-'}
            </div>
					</Descriptions> 
        </div>
        {vendor.vendor && <>
          <div className="blank-line"></div>
          <div className="ask-info">
            <div className="record-list-title">厂商信息</div>
            <Descriptions layout="vertical" className="pro-detail-title" column={4} style={{borderBottom: "none"}}>
              <DItem label="厂商客户名称">{vendor.vendorClient}</DItem>
              <DItem label="厂商ID">{vendor.vendor}</DItem>
              <DItem label="供应商">{vendor.supplierName}</DItem>
              <DItem label="厂商客户账号">{vendor.account}</DItem>
              <DItem label="密码">{vendor.password}</DItem>
              <DItem label="网站性质">{vendor.websitexz}</DItem>
              <DItem label="行业">{vendor.industry}</DItem>
              <DItem label="地区">{vendor.area}</DItem>
              <DItem label="到期时间">{vendor.dqdate}</DItem>
              <DItem label="结款状态">{vendor.jkstatus}</DItem>
              <DItem label="是否算KPI">{vendor.iskpi}</DItem>
              <DItem label="充值类型">{vendor.money}</DItem>
              <DItem label="出结算">{colInfo.outSettle}</DItem>
              <DItem label="端口识别号">{row.portIdentify}</DItem>
              <DItem label="原始厂商ID">{row.originalVendorId}</DItem>
              <DItem label="端口名称">{row.portName}</DItem>
              {
                internalSettlement &&
                <>
                  <DItem label="内部主体结算单价">{internalSettlement.percent === 0 || internalSettlement.percent == null ? '--' : internalSettlement.percent}</DItem>
                  <DItem label="内部主体结算实收">{internalSettlement.price === 0 || internalSettlement.price == null ? '--' : internalSettlement.price}</DItem>
                </>
              }
            </Descriptions>
          </div>
        </>}
        <div className="blank-line"></div>
        <div className="ask-info">
          <div className="record-list-title">折扣信息</div>
					{discountInfo ? <Descriptions layout="vertical" className="pro-detail-title" column={4} style={{borderBottom: "none"}}>
						<DItem label="客户名称">
              <div>{discountInfo.clientName}</div>
              <div>ID: {client.id}</div>
            </DItem>
            <DItem label="项目">{discountInfo.projectName}</DItem>
            <DItem label="产品">{discountInfo.productName}</DItem>
            <DItem label="一级行业">{discountInfo.industry1}</DItem>
            <DItem label="二级行业">{discountInfo.industry2}</DItem>
            <DItem label="折扣">{colInfo && +colInfo.colmarketprice === 0 ? '纯利' : discountInfo.colrebate}</DItem>
            <DItem label="供应商">
              <div>{discountInfo.supplier}</div>
              <div>ID: {orderExInfo.supplier}</div>
            </DItem>
            <DItem label="折扣类型">{discountInfo.discountType}</DItem>
					</Descriptions> : '-'}
        </div>
        <div className="blank-line"></div>
        <div className="ask-info">
          <div className="record-list-title">订单消耗信息</div>
					 <Descriptions layout="vertical" className="pro-detail-title" column={4} style={{borderBottom: "none"}}>
            <DItem label="可用消耗">{accDcorderInfo.available}</DItem>
            <DItem label="可用余额">{accDcorderInfo.balance}</DItem>
            <DItem label="已用消耗"><a onClick={onConsumptionList}>{accDcorderInfo.usedConsumption}</a></DItem>
            <DItem label="已用余额">{accDcorderInfo.usedBalance}</DItem>
					</Descriptions>
        </div>
        {row.coltype === 5 && (
          <>
            <div className="blank-line"></div>
            <div className="ask-info">
              <Descriptions title={<span className="font-striking">还款备注</span>} layout="horizontal" className="pro-detail-smailtitle">
                <div className="content">
                  {row.payRemark ? <span className="font-striking-content">{row.payRemark}</span> : '-'}
                </div>
              </Descriptions> 
            </div>
          </>
        )}
        <div className="blank-line"></div>
				<div className="record-list">
          <div className="record-list-title">审批记录</div>
          {aduitLog.length > 0 && <Descriptions layout="vertical" className="pro-detail-title" column={4} style={{borderBottom: "none", marginBottom: "-30px"}}>
						<DItem label="姓名"></DItem>
						<DItem label="时间"></DItem>
						<DItem label="状态"></DItem>
						<DItem label="审批意见"></DItem>
					</Descriptions>}
					{
						aduitLog.length > 0 ? aduitLog.map((item, index) => {
							return <Descriptions layout="horizontal" className="pro-detail-title" column={4} key={index} style={{borderBottom: "none", marginBottom: "-10px"}}>
								<DItem label="">{item.userInfo.staffName}</DItem>
								<DItem label="">{item.addTime}</DItem>
								<DItem label="">{item.status}</DItem>
								<DItem label="">{item.chargeMsg}</DItem>
							</Descriptions>
						}) : '-'
					}
				</div>
        {hasChargerPower && currentStatus == '折扣开始' && discountInfo.discountType == null && <>
        <div className="blank-line"></div>
        <div className="ask-info">
          <div className="record-list-title">处理信息</div>
					 <Descriptions layout="vertical" className="pro-detail-title" column={4} style={{borderBottom: "none"}}>
            <DItem label={<><span className="required-label">*</span> 折扣类型</>}>
              <Select
                placeholder="请选择折扣类型"
                style={{width: '200px'}}
                onChange={val => setDiscountType(val)}
              >
                {
                  [{name: '长期折扣', id: 0}, {name: '临时折扣', id: 1}].map(item => {
                    return <Select.Option key={item.id}>{item.name}</Select.Option>
                  })
                }
              </Select>
						</DItem>
					</Descriptions>
        </div>
        </>}
        {hasChargerPower && currentStatus == '提交提交' && <>
        <div className="blank-line"></div>
        <div className="ask-info">
          <div className="record-list-title">处理信息</div>
					 <Descriptions layout="vertical" className="pro-detail-title" column={4} style={{borderBottom: "none"}}>
            <DItem label={<><span className="required-label">*</span> 出结算</>}>
              <InputNumber
                step={0.01}
                min={0}
                style={{width: '200px'}}
                placeholder="请输入"
                value={outSettle}
                onChange={val => setOutSettle(val)}
            />
						</DItem>
					</Descriptions>
        </div>
        </>}
        {detail.modifyVendor !== -1 && <>
          <div className="blank-line"></div>
          <div className="ask-info">
            <div className="record-list-title">厂商信息</div>
            <Descriptions layout="vertical" className="pro-detail-title" column={4} style={{borderBottom: "none"}}>
              <DItem label={<><span className="required-label">*</span> 厂商客户名称</>}>
                <Input
                  style={{width: '200px'}}
                  placeholder="请输入"
                  value={vendorClient}
                  onChange={e => setVendorClient(e.target.value.trim())}
              />
              </DItem>
              <DItem label={<><span className="required-label">*</span> 厂商ID</>}>
                {detail.modifyVendor === 1 && <div>{vendor.vendor}</div>}
                {[0, 2].includes(detail.modifyVendor) && <Input
                  style={{width: '200px'}}
                  placeholder="请输入"
                  value={vendorId}
                  ref={input => {
                    if (input != null && vendorFocus) {
                      input.focus()
                    }
                  }}
                  onChange={e => setVendorId(e.target.value)}
                  onBlur={onVendorBlur}
                />}
              </DItem>
              <DItem label="供应商">
                <div>{orderExInfo.supplierName}</div> 
              </DItem>
              <DItem label={<><span className="required-label">*</span> 厂商客户账号</>}>
                <Input
                  style={{width: '200px'}}
                  placeholder="请输入"
                  value={account}
                  onChange={e => setAccount(e.target.value.trim())}
              />
              </DItem>
              <DItem label="密码">
                <Input
                  style={{width: '200px'}}
                  placeholder="请输入"
                  value={password}
                  onChange={e => setPassword(e.target.value.trim())}
              />
              </DItem>
              <DItem label="网站性质">
                <Input
                  style={{width: '200px'}}
                  placeholder="请输入"
                  value={websitexz}
                  onChange={e => setWebsitexz(e.target.value.trim())}
              />
              </DItem>
              <DItem label="行业">
                <Input
                  style={{width: '200px'}}
                  placeholder="请输入"
                  value={industry}
                  onChange={e => setIndustry(e.target.value.trim())}
              />
              </DItem>
              <DItem label="地区">
                <Input
                  style={{width: '200px'}}
                  placeholder="请输入"
                  value={area}
                  onChange={e => setArea(e.target.value.trim())}
              />
              </DItem>
              <DItem label="到期日期">
                {row.figtype == 2 && vendor.dqdate ? <DatePicker style={{width: '200px'}} allowClear={false} value={moment(dqdate, 'YYYY-MM-DD')} onChange={val => {
                  setDqdate(moment(val).format('YYYY-MM-DD'))
                }} /> : <DatePicker style={{width: '200px'}} allowClear={false} onChange={val => {
                  setDqdate(moment(val).format('YYYY-MM-DD'))
                }} />}
              </DItem>
              <DItem label={<><span className="required-label">*</span> 结款状态</>}>
                <Radio.Group style={{width: '250px'}} value={jkstatus} onChange={e => {
                  setJkstatus(e.target.value)
                }}>
                  <Radio value={1}>已结</Radio>
                  <Radio value={0}>未结</Radio>
                </Radio.Group>
              </DItem>
              <DItem label={<><span className="required-label">*</span> 是否算KPI</>}>
                <Radio.Group style={{width: '250px'}} value={iskpi} onChange={e => {
                  setIskpi(e.target.value)
                }}>
                  <Radio value={1}>是</Radio>
                  <Radio value={0}>否</Radio>
                </Radio.Group>
              </DItem>
              <DItem label={<><span className="required-label">*</span> 充值类型</>}>
                <Radio.Group style={{width: '250px'}} value={money} onChange={e => {
                  setMoney(e.target.value)
                }}>
                  <Radio value={1}>现金</Radio>
                  <Radio value={2}>虚拟金</Radio>
                  <Radio value={3}>固定账期</Radio>
                </Radio.Group>
              </DItem>
              <DItem label="出结算">
                <div>{colInfo.outSettle}</div>
              </DItem>
              <DItem label={<><span className="required-label">*</span> 端口识别号/端口名称</>}>
                <Select
                  placeholder="请选择"
                  style={{width: '200px'}}
                  onChange={val => setPortIdentify(val)}
                  value={portIdentify}
                  dropdownMatchSelectWidth={false}
                  showSearch
                  className="pay-account-select"
                  optionFilterProp="label"
                  allowClear
                  disabled={row.auditStatus === 4}
                >
                  {
                    portList.map((item, index) => (
                      <Select.Option
                        key={index}
                        value={item.portIdentify} 
                        label={`${item.portIdentify}\n${item.portName}`}
                      >
                        <div>
                          <div>{item.portIdentify}</div>
                          <div>{item.portName}</div>
                        </div>
                      </Select.Option>
                    ))
                  }
                </Select>
              </DItem>
              <DItem label={<><span className="required-label">*</span> 原始厂商ID</>}>
                <Input
                  style={{width: '200px'}}
                  placeholder="请输入"
                  value={originalVendorId}
                  onChange={e => setOriginalVendorId(e.target.value.trim())}
                  disabled={(row.auditStatus === 4 || [2, 3].includes(row.figtype)) && vendor.originalVendorId !== ''}
                />
              </DItem>
            </Descriptions>
          </div>
          {(detail.modifyVendor === 1 || detail.modifyVendor === 2) && !hasChargerPower &&
            <div className="btns">
              <Button type="primary" onClick={debounce(() => {onSaveVendorByModify(3)}, delay)}>保存</Button>
            </div>
          }
        </>}
        {
					auditAuth && <div>
            {
              hasChargerPower && (currentStatus === '提交受理' || currentStatus === '提交提交' || currentStatus === '提交生效') &&
              <TextArea
                style={{ marginBottom: '-10px' }}
                disabled={operateDisabled} 
                placeholder={submitTyle()}
                value={submitted}
                onChange={e => onSubmitted(e.target.value)}
              />
            }
					</div>
				}
				{
					auditAuth && <div className="btns">
            {userAuth && userAuth.fallowReplenish && <Button disabled={operateDisabled} onClick={() => {
              history.push(`/order${orderPageType}/edit`, {
                relationId: row.clientId, 
                id: row.id, 
                qId: row.agentId ? row.agentId : '', 
                auditStatus: row.auditStatus,
                vendorEdit: row.vendor ? row.vendor : ''
              })
            }} className="orange-btn">补充资料重提</Button>}
            {replenish && <Button disabled={operateDisabled} onClick={() => {leaveOutAudit(3)}} className="orange-btn">补充资料</Button>}
            {returnUp && <Button disabled={operateDisabled} onClick={() => {leaveOutAudit(2)}} className="orange-btn">转上级</Button>}
						{distribution && <Button onClick={debounce(() => {leaveOutAudit(4)}, delay)}>分配</Button>}
						{hasChargerPower && <Button disabled={operateDisabled} onClick={() => leaveOutAudit(1)}>驳回</Button>}
						{hasChargerPower && !['提交受理', '提交提交', '提交生效'].some(item => item == currentStatus) && <Button onClick={() => leaveOutAudit(0)} type="primary">通过</Button>}
						{hasChargerPower && currentStatus == '提交受理' && <Button disabled={operateDisabled} onClick={debounce(() => {leaveOutAudit(6)}, delay)} type="primary">受理</Button>}
						{hasChargerPower && currentStatus == '提交提交' && <Button disabled={operateDisabled} onClick={debounce(() => {leaveOutAudit(7)}, delay)}type="primary">已提交</Button>}
						{hasChargerPower && currentStatus == '提交生效' && <Button disabled={operateDisabled} onClick={debounce(() => {leaveOutAudit(8)}, delay)} type="primary">生效</Button>}
					</div>
				}
				<Modal
					title={agreeNode()}
					visible={modalVisible}
					onOk={debounce(() => {oprateHandleOk()}, delay)}
					onCancel={() => setModalVisible(false)}
					destroyOnClose={true}
          footer={[
            <Button key="back" onClick={() => setModalVisible(false)}>取消</Button>,
            <Button key="submit" type="primary" loading={reviewLoading} onClick={debounce(() => {oprateHandleOk()}, delay)}>确定</Button>
          ]}
				>
					<div className="officework-modal-content">
						<span className="label">审批意见：</span><Input.TextArea className="content-area" placeholder={resPlaceholder} onChange={getAreaTxt} rows={4} style={{width: "100%"}} maxLength={100} />
					</div>
				</Modal>
        <Modal
          title="分配受理人"
          visible={distributionVisible}
          onOk={debounce(() => {oprateHandleOkDist()}, delay)}
          onCancel={() => setDistributionVisible(false)}
          destroyOnClose={true}
          footer={[
            <Button key="back" onClick={() => setDistributionVisible(false)}>取消</Button>,
            <Button key="submit" type="primary" loading={reviewLoading} onClick={debounce(() => {oprateHandleOkDist()}, delay)}>确定</Button>
          ]}
        >
          <div className="officework-modal-content">
            <span style={{display: 'inline-block', width: '15%', height: '30px', lineHeight: '30px'}}><span style={{color: 'red'}}>*</span> 审批人</span>
            <Select
              placeholder="请选择审批人"
              style={{width: '80%'}}
              onChange={val => setDisStaffName(val)}
            >
              {
                detail.distributionStaff && detail.distributionStaff.map(item => {
                  return <Select.Option key={item.id}>{item.staffName}</Select.Option>
                })
              }
            </Select>
          </div>
        </Modal>
        <Modal
          title="转出"
          visible={turnOutVisible}
          onOk={debounce(() => {oprateHandleOkturnOut()}, delay)}
          onCancel={() => setTurnOutVisible(false)}
          destroyOnClose={true}
        >
          <div className="officework-modal-content">
            <span style={{display: 'inline-block', width: '15%', height: '30px', lineHeight: '30px'}}><span style={{color: 'red'}}>*</span> 转出至</span>
            <Select
              placeholder="请选择公司"
              style={{width: '80%'}}
              onChange={val => setCompany(val)}
            >
              {
                companyList.map(item => {
                  return <Select.Option key={item.id}>{item.name}</Select.Option>
                })
              }
            </Select>
          </div>
        </Modal>
        {/* 判断不能包含空格 */}
        <Modal
          title="提示"
          visible={vendorVisible}
          onOk={() => {setVendorVisible(false)}}
          onCancel={() => {setVendorVisible(false)}}
          destroyOnClose={true}
        >
          <div>
            <span>厂商ID中不允许有空格，请检查并重新填写，谢谢！</span>
          </div>
        </Modal>
         {/* 判断不允许有半角符号“-” */}
        <Modal
          title="提示"
          visible={vendorCharsVisible}
          onOk={() => { setVendorCharsVisible(false) }}
          onCancel={() => { setVendorCharsVisible(false) }}
          destroyOnClose={true}
        >
          <div>
            <span>厂商ID中不允许有全角符号“－”，如需要可用半角符号“-”代替，请检查并重新填写，谢谢！</span>
          </div>
        </Modal>
        <Drawer
          title={`已用消耗: ${base.number}`}
          width={880}
          onClose={() => setUseinfoVisible(false)}
          visible={useinfoVisible}
          destroyOnClose={true}
        >
          <Spin spinning={useinfoLoading}>
            <ConsumptionList
              setUseinfoVisible={setUseinfoVisible}
              setUseinfoLoading={setUseinfoLoading}
              orderPageType={orderPageType}
              adrId={adrId}
            />
          </Spin>
        </Drawer>
			</div>
		</Spin>
	)
}

export default DirectDetail